export default __webpack_public_path__ + "static/media/web-design.9caf8dfe.svg";